if (!customElements.get('ortho-bodymap')) {
  customElements.define('ortho-bodymap', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-zone-btn]');
        if (btn && this.contains(btn)) this.show(btn.getAttribute('data-zone-btn'));
      });
      this.show(this.dataset.zone);
    }
    show(zone) {
      if (!zone) return;
      this.dataset.zone = zone;
      this.querySelectorAll('[data-zone-btn]').forEach((b) => {
        b.setAttribute('aria-pressed', b.getAttribute('data-zone-btn') === zone ? 'true' : 'false');
      });
      this.querySelectorAll('[data-zone-panel]').forEach((p) => {
        p.hidden = p.getAttribute('data-zone-panel') !== zone;
      });
    }
  });
}
